import { DatePipe } from '@angular/common';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { formatDistanceToNow } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class GenericService {
  constructor(private datePipe: DatePipe) {}

  getCurrentDate(format: 'YYYYMMDD' = 'YYYYMMDD'): string {
    let date: any = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    let formattedDate;
    if (format === 'YYYYMMDD') formattedDate = `${year}${month}${day}`;
    else formattedDate = ''; // set according to the formats
    return formattedDate;
  }

  getCurrentDateNewFormat(): string {
    let date: any = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    let formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  }

  getCurrentTimeUnix(
    dateSelected?: string,
    format: 'YYYYMMDD' = 'YYYYMMDD'
  ): number {
    const dateString = dateSelected
      ? dateSelected
      : this.getCurrentDate(format);
    const year = parseInt(dateString.substring(0, 4), 10);
    const month = parseInt(dateString.substring(4, 6), 10) - 1; // Month is zero-based in JS Date
    const day = parseInt(dateString.substring(6, 8), 10);

    // Create a date in the local time zone
    const localDate = new Date(year, month, day, 0, 0, 0);

    // Get the local timezone offset in milliseconds and convert to seconds
    const timezoneOffset = localDate.getTimezoneOffset() * 60;

    // Get the Unix timestamp (in seconds)
    const unixTimestamp =
      Math.floor(localDate.getTime() / 1000) + timezoneOffset;

    return unixTimestamp;
  }

  getDateUnix(selectedDate: string) {
    const date = new Date(selectedDate);

    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');

    const formattedDate = `${year}${month}${day}`;

    return formattedDate;
  }

  getDisplayDate(
    dateString: string,
    isDuration: boolean = false,
    isTime: boolean = false
  ): string | null {
    if (!dateString) {
      return null;
    }

    const year = parseInt(dateString.substring(0, 4), 10);
    const month = parseInt(dateString.substring(4, 6), 10) - 1;
    const day = parseInt(dateString.substring(6, 8), 10);

    const date = new Date(year, month, day);
    if (isDuration) {
      return formatDistanceToNow(date, { addSuffix: true });
    } else if (isTime) {
      return this.datePipe.transform(date, 'dd MMM yyyy, hh:mm a');
    } else {
      return this.datePipe.transform(date, 'dd MMM yyyy');
    }
  }

  guessTimezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
